import type { BottomItem, LeftMenuType } from 'redux/reducers/leftSideMenu'

import { BottomList } from '../components/BottomList'
import { Item } from '../components/Item'
import { RecentList } from '../components/RecentList'

interface CampaignMenuProps {
	active: null | number | string
	bottomListActiveHandler: (item: any) => string | undefined
	clickOnLink: (item: any) => void
	leftSide: {
		bottomList: BottomItem[]
		label?: string
		list?: any[]
		type: LeftMenuType
	}
	linkBuilder: (type: LeftMenuType, id: string, archived?: boolean) => string
}

export function CampaignMenu({
	active,
	bottomListActiveHandler,
	clickOnLink,
	leftSide,
	linkBuilder
}: CampaignMenuProps) {
	if (!leftSide.bottomList?.length) return null

	return (
		<>
			<Item
				{...leftSide.bottomList[0]}
				isActive={active === leftSide.bottomList[0].id}
			/>

			<BottomList
				activeHandler={bottomListActiveHandler}
				items={leftSide.bottomList.slice(1)}
			/>

			<RecentList
				active={active}
				items={leftSide.list}
				label={leftSide.label}
				linkBuilder={linkBuilder}
				onClick={clickOnLink}
				type={leftSide.type}
			/>
		</>
	)
}
